import { forwardRef, useState } from 'react';

import { useScrollRef } from '../../../../utils/hooks/useScrollRef';

import { triggerEvent } from '../../../../utils/triggerEvent';

import arrowForwardIcon from './arrow-forward.svg';
import arrowBackIcon from './arrow-back.svg';

import { type IStepByStepForm } from './@interfaces';
import { type TParsedCategoryTree } from '../../../../modules/profile/shared/transformations/form/@interfaces';

import styles from './StepByStepForm.module.scss';

const StepByStepForm = forwardRef<HTMLFormElement, IStepByStepForm>(
  ({ categoryTree, onSelectedItem }, ref) => {
    const initialTitle = `Qual serviço de ${categoryTree.name} está precisando?`;

    const { scrollToTarget } = useScrollRef(ref as unknown as HTMLFormElement);

    const [title, setTitle] = useState(initialTitle);
    const [steps, setSteps] = useState([categoryTree.children]);

    const currentStep = steps.length;

    const handleNextStep = (category: TParsedCategoryTree) => {
      triggerEvent('step_by_step_form-next_step', {
        title,
        currentStep,
        categoryName: category.name,
      });

      if (category.children) {
        setTitle(category.name);

        setSteps((oldStep) => [...oldStep, category.children]);
      } else {
        onSelectedItem(category);
      }

      scrollToTarget();
    };

    const handleBackStep = () => {
      setTitle(initialTitle);

      triggerEvent('step_by_step_form-back_step', {
        title,
        currentStep,
      });

      setSteps((oldStep) => {
        return oldStep.filter((_, index) => index < oldStep.length - 1);
      });
    };

    return (
      <div className={`step-by-step-form ${styles['step-by-step-form']} `}>
        <div
          className={`step-by-step-form__header ${styles['step-by-step-form__header']} `}
        >
          {currentStep > 1 && (
            <button
              className={`step-by-step-form__back-button ${styles['step-by-step-form__back-button']} `}
              onClick={handleBackStep}
            >
              <img
                src={arrowBackIcon}
                alt="Seta para passo anterior"
                width={16}
                height={16}
              />
            </button>
          )}

          <h3
            className={`step-by-step-form__title ${styles['step-by-step-form__title']} `}
          >
            {title}
          </h3>
        </div>

        <ul>
          {steps[steps.length - 1].map((category) => (
            <li
              className={`step-by-step-form__item ${styles['step-by-step-form__item']} `}
              key={category.id}
            >
              <label>
                <input
                  type="radio"
                  id={`${category.id}`}
                  value={category.name}
                  onClick={() => handleNextStep(category)}
                />

                <p>{category.name}</p>

                <img
                  src={arrowForwardIcon}
                  alt="Seta para próximo passo"
                  width={24}
                  height={24}
                />
              </label>
            </li>
          ))}
        </ul>
      </div>
    );
  }
);

StepByStepForm.displayName = 'StepByStepForm';

export default StepByStepForm;
